import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface CreatorSpotlightProps {
  creator: {
    id: number;
    name: string;
    bio: string;
    image: string;
    alt: string;
    followers: string;
    stories: number;
    rating: number;
    badge: string;
  };
}

const CreatorSpotlight = ({ creator }: CreatorSpotlightProps) => {
  return (
    <div className="bg-card rounded-xl shadow-warm p-6 hover:shadow-warm-lg transition-all duration-300">
      <div className="flex items-start space-x-4 mb-4">
        <div className="relative">
          <div className="w-16 h-16 rounded-full overflow-hidden ring-2 ring-primary">
            <AppImage
              src={creator.image}
              alt={creator.alt}
              className="w-full h-full object-cover"
            />
          </div>

          {creator.badge && (
            <div className="absolute -bottom-1 -right-1 p-1 bg-accent rounded-full">
              <Icon name="CheckBadgeIcon" size={16} variant="solid" />
            </div>
          )}
        </div>

        <div className="flex-1">
          <h4 className="text-lg font-heading font-bold text-text-primary mb-1">
            {creator.name}
          </h4>

          <p className="text-sm text-text-secondary line-clamp-2 mb-2">
            {creator.bio}
          </p>

          <div className="flex items-center space-x-4 text-xs text-text-secondary">
            <div className="flex items-center space-x-1">
              <Icon name="UserGroupIcon" size={14} />
              <span>{creator.followers}</span>
            </div>

            <div className="flex items-center space-x-1">
              <Icon name="BookOpenIcon" size={14} />
              <span>{creator.stories} stories</span>
            </div>

            <div className="flex items-center space-x-1">
              <Icon name="StarIcon" size={14} variant="solid" className="text-accent" />
              <span>{creator.rating}</span>
            </div>
          </div>
        </div>
      </div>

      <button className="w-full flex items-center justify-center space-x-2 px-4 py-2.5 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary-dark transition-all duration-200">
        <Icon name="PlusIcon" size={18} />
        <span>Follow Creator</span>
      </button>
    </div>
  );
};

export default CreatorSpotlight;